module.exports = __webpack_public_path__ + "static/media/saucelabs.95a4a40c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/saucelabs.png
// module id = 185
// module chunks = 0